import {message, errorHandler, logout, loader} from '@/libs/helper'
import constants from '@/libs/constant/constants'
import {managePeopleSeats, getOrgPlanList} from '@/libs/api/api'
import {find} from 'lodash'
const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export default {
    props: {
        totalSeatsLeft: {
            type: Number,
            default: 0,
        },
        manageSeats: {
            type: Object,
            default: () => {}
        },
        refreshSeatCounts : {
            type: Function,
            default: () => {}
        }
    },
    
    data(){
        return{
            manageSetting: '', 
            isSeatOptions: false,
            totalSeats: 4, 
            seatsFilled: 2,
            seatsToUpdate: 0,
            selectedPlan: {},
            manageSettingOptions: [
                {label:'Upgrade', value:'upgrade'}, 
                {label:'Downgrade', value:'downgrade'}, 
                {label:'Manage seats', value:'manageSeats', disabled: true}
            ],
        }
    },

    computed:{
        seatsPercentage () {
            if (this.manageSeats.total_license && this.manageSeats.total_users) return (this.manageSeats.total_users/this.manageSeats.total_license)*100
            return 0
        },
        paymentToBeDone () {
            if (this.selectedPlan && this.selectedPlan.amount && this.manageSeats && this.manageSeats.total_license) {
                return (this.selectedPlan.amount * this.manageSeats.total_license)
            }
            return 0
        },
        paymentDate () {
            if (this.selectedPlan && this.selectedPlan.nextBillingDate) {
                const date = new Date(this.selectedPlan.nextBillingDate)
                let paymentDate = date.getDate()
                paymentDate = paymentDate + ' ' + monthNames[date.getMonth()]
                paymentDate = paymentDate + ' ' + date.getFullYear()
                return paymentDate
            }
            return ''
        },
        costTobeChargedOnUpgrade () {
            if (this.selectedPlan && this.selectedPlan.amount) {
                return (this.selectedPlan.amount * this.seatsToUpdate)
            }
            return 0
        }
    },

    mounted () {
        // fetch plans
        this.fetchOrgPlanList()
    },

    methods: {
        /**
         * update seats
         */
        updateSeats () {
            // if seats to be downgraded are greater than seats available throw error
            if (this.manageSetting === 'downgrade' && this.totalSeatsLeft < this.seatsToUpdate) {
                message(this, constants.messageType.ERROR, 'Seats to be downgraded can not be greater than total seats available')
                return
            }

            loader(this, true)

            // seats to be updated
            const seatsTobeUpdated = this.manageSetting === 'upgrade' ? this.manageSeats.total_license + this.seatsToUpdate : this.manageSeats.total_license - this.seatsToUpdate

            // body for api
            let body = {
                organisation: this.$route.params.id,
                quantity: seatsTobeUpdated
            }
            // api call
            managePeopleSeats(body).then((response) => {
                if(response.success) message(this, constants.messageType.SUCCESS, "Seats updated successfully")
                // refresh counts
                this.refreshSeatCounts()
                this.seatsToUpdate = 0
                loader(this, false)
            }).catch((error) => {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                loader(this, false)
            })
            
        },
        /**
         * fetch org plan list
         */
         fetchOrgPlanList () {
            getOrgPlanList({organisation: this.$route.params.id}).then(response => {
                const plan = find(response.plans || [], {userExistingPlan: true})
                this.selectedPlan = plan || {}
            })
        },
    }
}